import React from 'react';
import PropTypes from 'prop-types';

import './CarouselArrows.scss';
import ArrowBack from './ArrowBack';
import ArrowForward from './ArrowForward';

const CarouselArrows = ({ page, setPage, maxPage }) => {
  const handleSwipePage = value => {
    if ((page === 0 && value === -1) || (page === maxPage - 1 && value === 1)) {
      return;
    }
    setPage(page + value);
  };

  return (
    <div>
      <span
        role="button"
        className="arrow-button"
        onClick={() => handleSwipePage(-1)}
        tabIndex={0}
      >
        <ArrowBack />
      </span>
      <span
        role="button"
        className="arrow-button"
        onClick={() => handleSwipePage(1)}
        tabIndex={0}
      >
        <ArrowForward />
      </span>
    </div>
  );
};

export default CarouselArrows;

CarouselArrows.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  maxPage: PropTypes.number.isRequired
};
